/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetClubHouseQueryVariables = Exact<{
  clubhouseId: number;
}>;

export type GetClubHouseQuery = {
  __typename: 'query_root';
  clubhouse:
    | {
        __typename: 'clubhouse_club_house';
        id: number;
        banner: string | undefined;
        screens:
          | Array<{
              __typename: 'clubhouse_screen';
              id: number;
              duration: unknown;
              rank: unknown;
              team_id: number | undefined;
              phase_id: number | undefined;
              challenge_id: number | undefined;
              day: unknown;
              sponsors_category_id: number | undefined;
              template:
                | {
                    __typename: 'clubhouse_template';
                    slug: string | undefined;
                    id: number;
                  }
                | undefined;
              tournament:
                | {
                    __typename: 'tournaments_tournament';
                    id: number;
                    name: string | undefined;
                    tournament_ads:
                      | Array<{
                          __typename: 'tournaments_tournament_ad';
                          id: number;
                          image: string | undefined;
                          tournament_id: number | undefined;
                          url: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
              news:
                | {
                    __typename: 'news_news';
                    id: number;
                    image: string | undefined;
                    text: string | undefined;
                    title: string | undefined;
                  }
                | undefined;
            }>
          | undefined;
        club:
          | {
              __typename: 'clubs_club';
              color_primary: string | undefined;
              color_secondary: string | undefined;
              id: number;
              logo: string | undefined;
              short_name: string | undefined;
              name: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export const GetClubHouseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClubHouse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clubhouseId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'clubhouse' },
            name: { kind: 'Name', value: 'clubhouse_club_house_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'clubhouseId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'banner' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'screens' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rank' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'template' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phase_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challenge_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tournament' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tournament_ads' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'tournament_id',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sponsors_category_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'news' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'club' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color_primary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color_secondary' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClubHouseQuery, GetClubHouseQueryVariables>;
